import ConfigLoader from "ConfigLoader";
import Router from "Router";
import { Suspense } from "react";
import { RouterProvider } from "react-router-dom";
import { useAppDispatch } from "app/hooks";
import { parseURLtoState } from "slices/app";
import ErrorHandler from "components/features/ErrorHandler/ErrorHandler";
import Loader from "components/features/Loader/Loader";
import "customizations/lhs/assets/styles/main.scss";
import usePersistBuster from "app/usePersistBuster";

function App() {
  const dispatch = useAppDispatch();
  dispatch(parseURLtoState(window.location.search));
  usePersistBuster();

  return (
    <ErrorHandler>
      <ConfigLoader>
        <Suspense fallback={<Loader />}>
          <RouterProvider router={Router} />
        </Suspense>
      </ConfigLoader>
    </ErrorHandler>
  );
}

export default App;
